import React from "react";

import { Truncated } from "~/components/truncated";

import { BreadcrumbLayout } from "../BreadcrumbLayout";

export const GenericBreadcrumb: React.FC<
	React.PropsWithChildren<{
		name: string;
		isDirty: boolean;
		canBeSaved?: boolean;
		icon: React.ReactNode;
		to?: string;
	}>
> = ({ name, isDirty, canBeSaved = true, icon, children, to }) => {
	const tooltipPostfix = canBeSaved ? "Unsaved" : "Changed";

	return (
		<BreadcrumbLayout
			icon={icon}
			label={
				<div
					className="flex h-[26px] flex-row items-center justify-center"
					data-testid="view-details-breadcrumb-view-name"
				>
					<Truncated tooltip={isDirty ? `${name} * (${tooltipPostfix})` : name} truncate="middle">
						{isDirty ? `${name} *` : name}
					</Truncated>

					{children}
				</div>
			}
			to={to}
		/>
	);
};
